// export default Custom;
import React, { useEffect, useState } from "react";
import axios from "axios";
import Platter from "../../components/Platter/Platter";
import { useCart } from "../../context/CartContext"; // Import the cart context
// import OrderForm from "../../components/OrderForm/OrderForm";

const Custom = () => {
  const [platters, setPlatters] = useState([]); // List of all platters
  const [selectedPlatter, setSelectedPlatter] = useState(null); // Selected platter data
  const { cart, setCart } = useCart(); // Access cart context

  // Fetch all platters when the component mounts
  useEffect(() => {
    const fetchPlatters = async () => {
      try {
        const response = await axios.get(
          "https://ekhoni-khabo-server.vercel.app/api/v1/custom/platters"
        );
        setPlatters(response.data);
      } catch (error) {
        console.error("Error fetching platters:", error);
      }
    };
    fetchPlatters();
  }, []);

  // Fetch the selected platter's details
  const handlePlatterClick = async (platterId) => {
    try {
      const response = await axios.get(
        `https://ekhoni-khabo-server.vercel.app/api/v1/custom/platters/${platterId}`
      );
      setSelectedPlatter(response.data);
    } catch (error) {
      console.error("Error fetching platter details:", error);
    }
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-green-50 to-green-100 p-6">
        <h1 className="text-center text-3xl font-bold text-green-900 mb-8 pt-24">
          Choose a Package
        </h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Display the list of platters */}
          {platters.map((platter) => (
            <div
              key={platter._id}
              onClick={() => handlePlatterClick(platter._id)} // Fetch and set the selected platter
              className="bg-white border border-green-200 rounded-lg shadow-lg cursor-pointer hover:shadow-xl transition-shadow duration-300 p-6 w-80 h-30 flex flex-col justify-between"
            >
              <h2 className="text-xl font-semibold text-green-800 truncate">
                {platter.platterType}
              </h2>
              <p className="text-gray-600 line-clamp-2">
                {platter.foodItems.length} items available
              </p>
            </div>
          ))}
        </div>

        {/* Display the selected platter */}
        {selectedPlatter && <Platter platter={selectedPlatter} />}

        {/* Place Order Button */}
        {/* {cart.length > 0 && (
          <div className="flex justify-center mt-8 sticky z-50">
            <a
              href="/order#order-form"
              //   onClick={handlePlaceOrder}
              className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors duration-300"
            >
              Place Order
            </a>
          </div>
        )} */}
        {cart.length > 0 && (
          <div className="fixed bottom-10 left-0 right-25 md:bottom-0 md:left-0 md:right-0 flex justify-center p-4 bg-transparent z-50">
            <a
              href="/order#order-form"
              className="bg-green-600 text-white px-3 py-2 font-semibold rounded-lg hover:bg-green-700 transition-colors duration-300"
            >
              Place Order
            </a>
          </div>
        )}
      </div>
      {/* <OrderForm /> */}
    </>
  );
};

export default Custom;
